import React, { Component } from "react";
import HomeHeader from "./HomeHeader";
import HomeWork from "./HomeWork";
import HomeAboutUs from "./HomeAboutUs";
import HomeContact from "./HomeContact";
import NavMenu from "../../navmenu/NavMenu";
import Footer from "../../footer/Footer";
import "../../../styles/pages/home/Home.css";
import onScrollHandler from "../../../utilities/onScrollHandler";

export default class Home extends Component {
  componentDidMount() {
    this.onScrollHandler = new onScrollHandler();
  }
  render() {
    return (
      <div className="Home page-wrapper">
        <NavMenu />
        <HomeHeader />

        <HomeWork />
        <HomeAboutUs />
        <HomeContact />

        <Footer page={"home"} />
      </div>
    );
  }
}
